export default editor => {
    editor.DomComponents.addType('textarea', {
        // Make the editor understand when to bind `my-input-type`
        isComponent: el => {
            if (el.classList && el.classList.contains('et-textarea')) {
                return { type: 'textarea' }
            }
            return false
        },
        extend: 'default',
        // Model definition
        model: {
            // Default properties
            defaults: {
                tagName: 'textarea',
                name: 'Textfeld',
                draggable: '[data-gjs-type=column]',
                attributes: {
                    class: 'et-textarea',
                    placeholder: `Lorem ipsum dolor....`
                },
                highlightable: true,
                hoverable: true,
                traits:[
                    {
                        label: 'Platzhalter', // The label you will see in Settings
                        name: 'placeholder', // The name of the attribute/property to use on component
                    }
                ]
            }
        }
    });
}
